// extracted by mini-css-extract-plugin
module.exports = {"text":"Members_text__1Sd1I","item":"Members_item__2K-bt","absoluteWrapper":"Members_absoluteWrapper__yeN3R","role":"Members_role__33Nj5","gray":"Members_gray__y5MyA"};